import React, {CSSProperties} from 'react';
import type {UniqueIdentifier} from '@dnd-kit/core';
import {AnimateLayoutChanges, useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

import {TreeItem, Props as TreeItemProps} from './TreeItem';
// import {iOS} from '../../utilities';

interface Props extends TreeItemProps {
  id: UniqueIdentifier;
}

const animateLayoutChanges: AnimateLayoutChanges = ({isSorting, wasDragging}) =>
  isSorting || wasDragging ? false : true;

export function SortableTreeItem({id, depth, activePageId, category, visible, missingMedia, isDragActive, ...props}: Props) {
  const {
    attributes,
    isDragging,
    isSorting,
    listeners,
    setDraggableNodeRef,
    setDroppableNodeRef,
    transform,
    transition
  } = useSortable({
    id,
    animateLayoutChanges,
    disabled: !isDragActive
  });
  // Determine background color based on state
  let backgroundColor = "#2A2A2B";
  if (isDragging || ((category !== "layers") && activePageId && (activePageId === Number(id)))) {
    backgroundColor = "rgba(61,145,255,1)";
  } else if (missingMedia) {
    backgroundColor = "rgba(255, 193, 7, 0.3)"; // Yellow/amber warning color
  }

  const style: CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition,
    background: backgroundColor,
  };
  // console.log('category', category)

  return (
    <TreeItem
      ref={setDraggableNodeRef}
      wrapperRef={setDroppableNodeRef}
      style={style}
      depth={depth}
      category={category}
      visible={visible}
      missingMedia={missingMedia}
      activePageId={activePageId === Number(id) ? 1 : 0}
      ghost={isDragging}
      disableInteraction={isSorting}
      handleProps={{
        ...attributes,
        ...listeners,
      }}
      {...props}
    />
  );
}
